import React, { Component } from 'react';
import PropTypes from 'prop-types';
import css from '../../styles/button';
import Link from '../Link';

export class Button extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        loading: PropTypes.bool,
        link: PropTypes.string,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        type: PropTypes.oneOf([
            'default',
            'primary',
            'utility',
            'wide',
            'tab',
            'transparent',
        ]),
        metaTitle: PropTypes.string,
    };

    static defaultProps = {
        type: 'default',
        disabled: false,
    };

    constructor(props) {
        super(props);

        this._onClick = () => {
            const { onClick } = this.props;

            if (!onClick) return;

            this.props.onClick();
        };
    }

    render() {
        const {
            disabled,
            label,
            link,
            type,
            loading,
        } = this.props;
        const classes = [];

        if (type === 'wide') {
            classes.push(css.buttonWide);
        } else if (type === 'primary') {
            classes.push(css.buttonPrimary);
        } else if (type === 'utility') {
            classes.push(css.buttonUtility);
        } else if (type === 'tab') {
            classes.push(css.buttonTab);
        } else if (type === 'transparent') {
            classes.push(css.buttonTransparent);
        } else {
            classes.push(css.button);
        }

        if (loading || disabled) {
            classes.push(css.buttonDisabled);
        }

        // if (disabled) {
        //     return <div className={[buttonClass, css.buttonLoading].join(' ')}>
        //      Disabled button
        //     </div>;
        // }

        return (
            <Link
                className={ classes.join(' ') }
                onClick={ this._onClick }
                metaTitle= { this.props.metaTitle }
                to={ link }
            >{ label }</Link>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/buttonpanel/Button.js
 **/